export default __webpack_public_path__ + "static/media/NavLogo.09f840af.png";